/// <reference types="vite/client" />
import { queryOptions, useQuery, UseQueryResult } from '@tanstack/react-query';
import useLOC from '../useLOC/useLOC';
import { NextPayment } from 'merchant-api/types';
import { spiceroad } from '..';

export interface LOCPaymentProps {
  LOCPaymentLoading: boolean;
  LOCPayment: NextPayment | null | undefined;
  LOCPaymentError: any;
  query: UseQueryResult<NextPayment>;
}

const getLOCNextPayment = (locId: string) =>
  spiceroad
    .get<NextPayment>(`/v1/locs/${locId}/payment/next`)
    .then((res) => res.data);

export const getLOCNextPaymentOpts = (locId: string) =>
  queryOptions<NextPayment>({
    queryKey: ['locPayment', locId],
    queryFn: () => getLOCNextPayment(locId),
  });

export function getLOCPayment(): LOCPaymentProps {
  const { activeLOC, locLoading, locError } = useLOC();
  const LocId = activeLOC?.id;
  const query = useQuery({
    ...getLOCNextPaymentOpts(LocId!),
    enabled: !!LocId,
  });
  const { data, error, isLoading } = query;
  return {
    LOCPayment: data,
    LOCPaymentLoading: isLoading || locLoading,
    LOCPaymentError: error || locError,
    query,
  };
}

export default getLOCPayment;
